var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoOfHearts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.589,
    height: 19.589,
    viewBox: "0 0 19.589 19.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.886,
    y1: 0.703,
    x2: 0.079,
    y2: 0.155,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "two-of-hearts_1_",
    "data-name": "two-of-hearts (1)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M11.893,19.239C9.64,17.672,3.959,13.166,3.959,7.877A3.929,3.929,0,0,1,7.877,3.959a4.4,4.4,0,0,1,2.645.979l1.273,1.175,1.273-1.175a4.4,4.4,0,0,1,2.645-.979A3.929,3.929,0,0,1,19.63,7.877v.1a5.049,5.049,0,0,1,1.959.882V7.877A5.894,5.894,0,0,0,15.713,2a6.241,6.241,0,0,0-3.918,1.469A6.241,6.241,0,0,0,7.877,2,5.894,5.894,0,0,0,2,7.877c0,7.836,9.795,13.713,9.795,13.713a20.591,20.591,0,0,0,2.253-1.371,18.8,18.8,0,0,1-1.469-1.371A2.455,2.455,0,0,1,11.893,19.239Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M18.856,10a2.735,2.735,0,0,0-1.959.784A2.735,2.735,0,0,0,14.938,10,3.013,3.013,0,0,0,12,12.938c0,4.408,4.9,6.856,4.9,6.856s4.9-2.938,4.9-6.856A3.013,3.013,0,0,0,18.856,10Z",
    transform: "translate(-0.205 -0.164)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoOfHearts);
export default __webpack_public_path__ + "static/media/two-of-hearts.efb6909ea537aa871e32669812aca348.svg";
export { ForwardRef as ReactComponent };